import ToolbarButton from "app/WebView/Toolbar/ToolbarButton"
import ToolbarIcon from "app/WebView/Toolbar/ToolbarIcon"
import {ToolbarButtons} from "app/WebView/Toolbar/ToolbarView.model"
import React from "react"
import {ButtonGroup} from "react-bootstrap"

interface ToolbarViewProps {
  buttons: ToolbarButtons
}

function ToolbarView({buttons}: ToolbarViewProps) {
  const keys = Object.keys(buttons)
  return keys.length < 1 ? null : (
    <>
      {keys.map((group) => {
        if (buttons[group].length < 1)
          return null

        return (
          <ButtonGroup
            key={group}
          >
            {buttons[group].map(button => {
              let key = button.id
              if (button.type)
                key += `-${button.type}`

              if (button.icon) {
                return <ToolbarIcon key={key} button={button}/>
              } else {
                return <ToolbarButton key={key} button={button}/>
              }
            })}
          </ButtonGroup>
        )
      })}
    </>
  )
}

export default ToolbarView
